<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="英文材料的描述信息" prop="descriptionEn"
                :rules="[
                  {required: true, message:'英文材料的描述信息不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.descriptionEn" placeholder="请填写英文材料的描述信息"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文材料的描述信息" prop="descriptionCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.descriptionCn" placeholder="请填写中文材料的描述信息"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="规格(英)" prop="specEn"
                :rules="[
                  {required: true, message:'规格(英)不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.specEn" placeholder="请填写规格(英)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="规格(中)" prop="specCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.specCn" placeholder="请填写规格(中)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="品牌(英)" prop="brandEn"
                :rules="[
                  {required: true, message:'品牌(英)不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.brandEn" placeholder="请填写品牌(英)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="规格(中)" prop="brandCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.brandCn" placeholder="请填写规格(中)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="数量" prop="quantity"
                :rules="[
                 ]">
              <el-input v-model="inputForm.quantity" placeholder="请填写数量"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="关联材料id" prop="itemId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.itemId" placeholder="请填写关联材料id"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmMaterialInfoService from '@/api/cecunmmaterialinfo/cecUnmMaterialInfoService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          descriptionEn: '',
          descriptionCn: '',
          specEn: '',
          specCn: '',
          brandEn: '',
          brandCn: '',
          quantity: '',
          itemId: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM项目材料信息`
        } else if (method === 'edit') {
          this.title = '修改UM项目材料信息'
        } else if (method === 'view') {
          this.title = '查看UM项目材料信息'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmMaterialInfoService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmMaterialInfoService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
